export function hasDirective(directive: string, chordPro: string) {
  return chordPro.indexOf(`{${directive}:`) !== -1;
}

export function stripDirective(directive: string, chordPro: string) {
  if (!hasDirective(directive, chordPro)) {
    return chordPro;
  }
  const re = new RegExp(`{${directive}[^}]+}\n*`, "g");
  return chordPro.replace(re, "");
}

export function insertDirective(
  directive: string,
  value: string,
  chordPro: string,
) {
  return `{${directive}: ${value}}\n${chordPro}`;
}

// aka get chords + lyrics
export function stripAllDirectives(chordPro: string) {
  const re = /{.[^}]+}\n*/g;
  return chordPro.replace(re, "");
}

function stripAllChords(chordPro: string) {
  const re = /\[.*?\]\n*/g;
  return chordPro.replace(re, "");
}

export function getLyrics(chordPro: string) {
  return stripAllChords(stripAllDirectives(chordPro));
}
